import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var Language;
(function (Language) {
    Language["EN"] = "EN";
    Language["DE"] = "DE";
    Language["FR"] = "FR";
    Language["IT"] = "IT";
})(Language || (Language = {}));
